module.exports = __webpack_public_path__ + "static/media/lock-update.e9fffcbb.svg";